// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WtcPQ","fullView":"styles_fullView__wUdnx"};